import { useAccountContext } from '@seek/hirer-graphql-react';
import { Box, ContentBlock } from 'braid-design-system';
import { useEffect } from 'react';
import { TrackJS } from 'trackjs';

import { AnnouncementGoToMarket } from 'src/App/components/AnnouncementGoToMarket';
import { shouldRenderGoToMarketInSite } from 'src/App/components/AnnouncementGoToMarket/utils/shouldRenderGoToMarket';
import { ErrorPage } from 'src/App/components/ErrorPage/ErrorPage';
import { HeaderAndFooterWrapper } from 'src/App/layouts/JobsListPage/HeaderAndFooterWrapper';
import { useConfig } from 'src/hooks/useConfig';
import {
  defaultTrackingData,
  TrackingContext,
  type TrackingData,
} from 'src/hooks/useTracking';
import { PageLoadTracker } from 'src/modules/events/PageLoadTracker';

import JobsList from './JobsList';

export const JobsListPage = () => {
  const { accountContext, error } = useAccountContext();
  const config = useConfig();

  const trackingData: TrackingData = {
    ...defaultTrackingData,
    userId: accountContext?.currentUser?.id,
    seekAdvertiserId: accountContext?.currentAdvertiser?.seekId,
  };

  useEffect(() => {
    if (accountContext?.currentAdvertiser?.seekId) {
      TrackJS.addMetadata(
        'seekAdvertiserId',
        accountContext?.currentAdvertiser?.seekId,
      );
    }
    if (accountContext?.currentUser?.id) {
      TrackJS.addMetadata('userId', accountContext.currentUser.id);
    }
    // can we stop doing this? advertiser id is not intended to be used in front-end anymore.
    if (accountContext?.currentAdvertiser?.advertiserId) {
      TrackJS.addMetadata(
        'adcentreAdvertiserId',
        accountContext?.currentAdvertiser?.advertiserId,
      );
    }
  }, [accountContext]);

  const { environment, site, locale } = config;
  const isStaging = environment === 'staging';

  if (error) {
    return (
      <TrackingContext.Provider value={{ trackingData }}>
        <HeaderAndFooterWrapper
          site={site}
          locale={locale}
          isStaging={isStaging}
        >
          <ContentBlock width="large">
            <Box display="flex" justifyContent="center" padding="large">
              <ErrorPage />
            </Box>
          </ContentBlock>
        </HeaderAndFooterWrapper>
      </TrackingContext.Provider>
    );
  }
  return (
    <TrackingContext.Provider value={{ trackingData }}>
      <PageLoadTracker />
      <HeaderAndFooterWrapper site={site} locale={locale} isStaging={isStaging}>
        {shouldRenderGoToMarketInSite(site) && <AnnouncementGoToMarket />}
        <JobsList />
      </HeaderAndFooterWrapper>
    </TrackingContext.Provider>
  );
};
